import { Logger as BaseLogger } from '@common';

export class Logger extends BaseLogger {
  constructor() {
    super({ logger: console, prefix: ['MoonPay React SDK'] });
  }
}
